// ********Save/Update button function API */
export const SaveVendorGroupDetails = async (VenderGroup, code) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(VenderGroup),

        }

        const response = await fetch(`${ApiURL}SupplierGroup/SaveSupplierGroup/${code}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Record Already Exsist!") {
                return { success: false, data: responseData.data };
            } else if (responseData.data == "Code Already Exsist!") {
                return { success: false, data: responseData.data };
            } else {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveVendorGroupDetails error:", error);
        return { success: false, data: "An error occurred." };
    }
};
// ********End of Save/Update button function API */

// ********Delete button function API */
export const DeleteVendorGroupDetails = async (rowDelete) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(rowDelete)
        };

        const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {

            if (responseData.data == "Cannot Delete, Record Already Used!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data };
            }

        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("DeleteVendorGroupDetails error:", error);
    }
};
// ********End of Delete button function API */


// *** Get and Set values when user search code function API*/
export const VendorGroupGetData = async (strSupGroupCode) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        };
        const response = await fetch(`${ApiURL}SupplierGroup/search/${strSupGroupCode}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.options.length > 0) {
                return { success: true, data: responseData.options[0] };
            }
        } else {
            return { success: false, data: {} };
        }
    }
    catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}
// *** End of Get and Set values when user search code function API*/
